<template>
  <div>
    <NotificationItem
      v-for="(item, index) in items"
      :key="index"
      :title="title(item)"
      :message="messages(item.message)"
      :date="item.timestamp"
      :attachments="item.attachment ? [item.attachment]: []"
      :can-delete="canDelete(item)"
      @delete="onDeleteItem(item)"
    />
  </div>
</template>

<script>
import NotificationItem from './NotificationItem';

export default {
  name: 'NotificationList',
  components: {
    NotificationItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    title(item) {
      if (item.sender) return `${item.sender.user.first_name} ${item.sender.user.last_name}`;
      return 'Admin';
    },
    messages(message) {
      const replaced_message = message.replace('/album/', '/assets/');
      return replaced_message;
    },
    onDeleteItem(item) {
      this.$emit('delete-item', item.pk);
    },
    canDelete(item) {
      const { profile } = this.$store.state.account.user;
      const { role } = profile;
      const isSender = item.sender ? (profile.pk === item.sender.pk) : false;
      return role.includes('manager') || isSender;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
